import { resolve } from 'framework/script_utilities/object-navigator';

export class HideByPropertyValueConverter {
  toView(items: unknown[], path: string) {
    return items?.filter(i => !(resolve(i, path) === true));
  }
}
